var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-navigation"},[(_vm.$mq !== 'mobile')?_c('header-overview-link',{staticClass:"overview-link"}):_vm._e(),_c('header-children')],1)}
var staticRenderFns = []

export { render, staticRenderFns }